export const callCenterPhone = process.env.REACT_APP_PHONE;
export const location = process.env.REACT_APP_LOCATION;
export const apiUrl = process.env.REACT_APP_API_URL;
export const mediaUrl = process.env.REACT_APP_MEDIA_URL;
export const bannerMediaUrl = process.env.REACT_APP_BANNER_MEDIA_URL;
export const pizzaCategoryId = process.env.REACT_APP_PIZZA_CATEGORY_ID;
export const drinksCategoryId = process.env.REACT_APP_DRINKS_CATEGORY_ID;
export const apiUrl2 = process.env.REACT_APP_API_URL2;